import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { CheckboxModule } from 'primeng/checkbox';

export interface CheckboxProps extends FormlyFieldProps {
  trueValue?: any;
  falseValue?: any;
}

export interface FormlyCheckboxFieldConfig
  extends FormlyFieldConfig<CheckboxProps> {
  type: 'checkbox';
}

@Component({
  selector: 'kon-checkbox-type',
  imports: [CheckboxModule, ReactiveFormsModule],
  template: `
    <div class="flex items-center">
      <p-checkbox
        [inputId]="key.toString()"
        [binary]="true"
        [trueValue]="props.trueValue ?? true"
        [falseValue]="props.falseValue ?? false"
        [formControl]="formControl"
        (onChange)="props.change && props.change(field, $event)"
      />
      @if (props.label) {
        <label [for]="key.toString()" class="pl-2">{{ props.label }}</label>
      }
    </div>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyCheckboxTypeComponent extends FieldType<
  FieldTypeConfig<CheckboxProps>
> {}
